import { Injectable } from '@angular/core';
import { noop } from 'lodash';
import {
    IDatiqLink,
    DATIQ_LINK,
    datiqInputCreateId,
} from '@dat/datiq-core/models';

@Injectable({
    providedIn: 'root',
})
export class DatiqLinkService {
    constructor() {}

    isRoute(link: IDatiqLink): boolean {
        return !!link?.route?.length;
    }

    isExternalLink(link: IDatiqLink) {
        return !!link?.href?.length;
    }

    getLinkId(id: string): string {
        return datiqInputCreateId([id, DATIQ_LINK]);
    }
    navigate(link: IDatiqLink) {
        this.isExternalLink(link) ? this.navigateToLink(link) : noop();
    }
    navigateToLink(link: IDatiqLink) {
        link?.newTab
            ? window.open(link.href, '_blank')
            : (window.location.href = link.href);
    }

    getInputId(id: string, datiqLink: IDatiqLink): string {
        return id ?? datiqLink?.id;
    }
}
